import { Injectable } from '@angular/core';
import { IQuery } from '@app/shared/interfaces/query';
import { UtilService } from '@app/shared/services/utils/util.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Tag, colorBackground } from '../../models/tag.model';
import { TagDropdownDataSource } from '../dropdowns/tag-dropdown/tag-dropdown-data-source.interface';
import { DataService } from '@app/shared/services/data/data.service';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private _itemTags: TagDropdownDataSource[] = [];
  private _currentSelectedTags = [];

  constructor(private dataService: DataService) {}

  public getList(query: IQuery): Observable<any> {
    query?.searchValues && !query?.searchFields && (query.searchFields = 'name');
    !query?.sort && (query.sort = 'name');
    const url = 'Tags' + UtilService.fillUrl(query);
    return this.dataService.get(url);
  }

  get(id: string): Observable<any> {
    const url = `Tags/${id}`;
    return this.dataService.get(url).pipe(map((response: Response | any) => response));
  }

  patch(patch: any, id: string) {
    const url = `Tags/${id}`;
    return this.dataService.patch(url, patch).pipe(map((response: Response | any) => response));
  }

  create(tag: Tag) {
    const url = 'Tags';
    return this.dataService.post(url, tag).pipe(map((response: Response | any) => response));
  }

  delete(id: string) {
    const url = `Tags/${id}`;
    return this.dataService.delete(url);
  }

  deleteByCollection(id: string, collection: string, objId: string) {
    const url = `Tags/${id}/${collection}/${objId}`;
    return this.dataService.delete(url);
  }

  getStickyBorderColor = (color): string => {
    if (!color) {
      return;
    }

    return colorBackground[color];
  };

  set tags(tags: TagDropdownDataSource[]) {
    this._itemTags = tags;
  }

  get tags() {
    return Array.isArray(this._itemTags) ? [...this._itemTags] : [];
  }

  get currentTags(): any[] {
    return [...this._currentSelectedTags].sort((a, b) => a.name.localeCompare(b.name));
  }

  set currentTags(tags: any[]) {
    this._currentSelectedTags = tags;
  }
}
